export default __webpack_public_path__ + "static/media/bt2.bcde13ee.jpeg";